import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import PoemRow from '../components/PoemRow';
import { Grid } from '@material-ui/core';

const App = ({ data }) => {
  const rows = data.allMdx.nodes.reduce(function(rows, key, index) {
    return (index % 3 === 0 ? rows.push([key])
      : rows[rows.length - 1].push(key)) && rows;
  }, []);

  const [width, setWindowWidth] = useState(1920);

  useEffect (() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () =>
    window.removeEventListener("resize", updateDimensions);
  }, []);

  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  }

  return (
    <Layout>
      <Grid container spacing={1}>
        {
          rows.map((row, i) => (
            <Grid container item xs={'auto'} spacing={3} key={'row_' + i}>
              <PoemRow row={row} mobile={width < 1024}/>
            </Grid>
          ))
        }
      </Grid>
    </Layout>
  );
}

export const query = graphql`
  query {
    allMdx(sort: {fields: frontmatter___date, order: DESC}) {
      nodes {
        frontmatter {
          date(formatString: "YYYY/MM/DD")
          title
          abbreviated
          preview
        }
        id
        slug
      }
    }
  }
`

export default App;
